// Third party
import React from 'react';
import moment from 'moment';

// Redux
import { AnnouncementBody, UserAnnouncement } from '@/redux/modules/types/announcements';

// Components
import NotificationBody from '@/views/components/notification/NotificationBody';

// Utils
import { formatMessage, FormattedMessage } from '@/utils/i18n';

type Props = {
  announcement: UserAnnouncement;
};

const MaterialChangeItem: React.FC<Props> = ({ announcement }: Props) => (
  <div className="notification-card material-change">
    <div className="notification-status">
      {!announcement.read && (
        <span className="unread-dot" title={formatMessage('AnnouncementsAdvisor.Unread')} aria-label={formatMessage('AnnouncementsAdvisor.Unread')} />
      )}
      <i className="icon-info1" aria-hidden />
    </div>
    <div className="notification-content">
      <FormattedMessage tagName="h4" id="Notification.MaterialChange.Title" />
      <FormattedMessage tagName="span" id="Notification.MaterialChange.Header" values={{ count: (announcement.body as Array<AnnouncementBody>).length }} />
      <NotificationBody item={announcement} />
      <div className="notification-details">
        <span className="me-2">{moment(announcement.notificationDate).format(formatMessage('Common.DateFormats.DateWithTime'))}</span>
      </div>
    </div>
  </div>
);

export default MaterialChangeItem;
